export type RevenueTransaction = {
  id: string;
  date: string;
  customer: string;
  className: string;
  amount: number;
  paymentMethod: "CASH" | "BANK_TRANSFER" | "CARD" | "MOMO";
  status: "PAID" | "PENDING" | "REFUNDED";
};

export const revenueKpiMock = {
  totalRevenue: 1842500000,
  thisMonth: 286400000,
  lastMonth: 247800000,
  growthPercent: 15.6,
  activeStudents: 312,
  newStudents: 47,
  averagePerStudent: 5908650,
  outstanding: 32400000,
};

export const revenueByMonthMock = [
  { month: 1, value: 142000000 },
  { month: 2, value: 168000000 },
  { month: 3, value: 156000000 },
  { month: 4, value: 198000000 },
  { month: 5, value: 221000000 },
  { month: 6, value: 247800000 },
  { month: 7, value: 286400000 },
];

export const recentTransactionsMock: RevenueTransaction[] = [
  {
    id: "TX-2026-00128",
    date: "08/06/2026",
    customer: "Nguyễn Minh Anh", // i18n-ignore
    className: "Bơi cơ bản - 12 buổi", // i18n-ignore
    amount: 3600000,
    paymentMethod: "BANK_TRANSFER",
    status: "PAID",
  },
  {
    id: "TX-2026-00127",
    date: "08/06/2026",
    customer: "Trần Quốc Bảo", // i18n-ignore
    className: "Bóng rổ thiếu nhi", // i18n-ignore
    amount: 2800000,
    paymentMethod: "CASH",
    status: "PAID",
  },
  {
    id: "TX-2026-00126",
    date: "07/06/2026",
    customer: "Lê Hà My", // i18n-ignore
    className: "Yoga nâng cao", // i18n-ignore
    amount: 1950000,
    paymentMethod: "MOMO",
    status: "PAID",
  },
  {
    id: "TX-2026-00125",
    date: "07/06/2026",
    customer: "Phạm Gia Khang", // i18n-ignore
    className: "Cầu lông trẻ em", // i18n-ignore
    amount: 2200000,
    paymentMethod: "CARD",
    status: "PENDING",
  },
  {
    id: "TX-2026-00124",
    date: "06/06/2026",
    customer: "Đỗ Thanh Tùng", // i18n-ignore
    className: "Karate - 24 buổi", // i18n-ignore
    amount: 5400000,
    paymentMethod: "BANK_TRANSFER",
    status: "PAID",
  },
  {
    id: "TX-2026-00123",
    date: "06/06/2026",
    customer: "Hoàng Yến Nhi", // i18n-ignore
    className: "Bơi nâng cao", // i18n-ignore
    amount: 3200000,
    paymentMethod: "MOMO",
    status: "REFUNDED",
  },
  {
    id: "TX-2026-00122",
    date: "05/06/2026",
    customer: "Vũ Đức Thành", // i18n-ignore
    className: "Bóng rổ người lớn", // i18n-ignore
    amount: 4100000,
    paymentMethod: "BANK_TRANSFER",
    status: "PAID",
  },
  {
    id: "TX-2026-00121",
    date: "05/06/2026",
    customer: "Bùi Khánh Linh", // i18n-ignore
    className: "Yoga cơ bản", // i18n-ignore
    amount: 1750000,
    paymentMethod: "CASH",
    status: "PAID",
  },
];

export const formatVnd = (value: number) => {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(value);
};
